module.exports = __webpack_public_path__ + "img/128152d.png";